export const BASE_CLASS = 'mt-CardThumbnail'
export const BASE_CLASS_CONTENT = `${BASE_CLASS}Content`
export const BASE_CLASS_MEDIA = `${BASE_CLASS}Media`
export const DEFAULT_PHOTO = 'images/no-photo.png'
const DESKTOP_WIDTH = 252
export const DEFAULT_WIDTH = DESKTOP_WIDTH
export const SIZES = {
  SMALL: 'small',
  LARGE: 'large'
}
export const ASPECT_RATIOS = {
  FULL_SCREEN: 'fullScreen',
  WIDE_SCREEN: 'wideScreen',
  FULL_FRAME: 'fullFrame'
}
const EMPTY_STRING = ''
export const DEFAULT_ALT = EMPTY_STRING
